import { v4 as uuidv4 } from 'uuid';

export function MinicartProductListQuantitySelector(props = {}, childrenComponents = []) {
	return {
		componentName: 'MinicartProductListQuantitySelector',
		componentId: uuidv4(),
		props: Object.assign(
			{
				mode: 'default',
				quantitySelectorStep: 'unitMultiplier',
			},
			props,
		),
		childrenComponents,
	};
}
